export enum TaskStatus {
  Todo = 'Todo',
  InProgress = 'InProgress',
  InReview = 'InReview',
  Done = 'Done',
  Blocked = 'Blocked',
  Cancelled = 'Cancelled'
}

export enum TaskPriority {
  Lowest = 'Lowest',
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Highest = 'Highest'
}

export enum TaskType {
  Task = 'Task',
  Bug = 'Bug',
  Story = 'Story',
  Epic = 'Epic',
  SubTask = 'SubTask'
}

export interface Task {
  id: number;
  title: string;
  description: string;
  status: TaskStatus;
  priority: TaskPriority;
  type: TaskType;
  feedItemId?: number;
  clientId?: number;
  assignedToUserId: string;
  createdByUserId: string;
  assignedToUserName: string | null;
  createdByUserName: string | null;
  dueDate?: string;
  startedAt?: string;
  completedAt?: string;
  createdAt: string;
  updatedAt?: string;
  isAiGenerated: boolean;
  aiGenerationPrompt?: string;
  storyPoints?: number;
  labels: string[];
  acceptanceCriteria?: string;
  comments: TaskComment[];
}

export interface TaskComment {
  id: number;
  taskId: number;
  userId: string;
  authorName: string | null;
  content: string;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateTaskRequest {
  title: string;
  description: string;
  type: TaskType;
  priority: TaskPriority;
  assignedToUserId?: string;
  feedItemId?: number;
  clientId?: number;
  dueDate?: string;
  storyPoints?: number;
  labels?: string[];
  acceptanceCriteria?: string;
  isAiGenerated: boolean;
  aiGenerationPrompt?: string;
}

export interface TaskDescriptionSuggestion {
  title: string;
  description: string;
  acceptanceCriteria?: string;
  storyPoints?: number;
  priority: TaskPriority;
  labels: string[];
  isAiGenerated: boolean;
  generationPrompt?: string;
}

export interface GenerateTaskDescriptionRequest {
  feedItemTitle: string;
  feedItemDescription: string;
  clientName?: string;
  additionalContext?: string;
}
